const STORAGE_KEY = 'superoti.warehouse.delman.device'

export type DelmanDeviceBinding = {
  deviceId: string
  deviceUid: string
  deviceName: string
  brandId: string
  delmanUserId: string
  delmanName: string
  warehouseId?: string
  warehouseName?: string
  deviceType: 'warehouse_delman_mobile'
  activatedAt: string
}

export function getDelmanDevice(): DelmanDeviceBinding | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as DelmanDeviceBinding
  } catch {
    return null
  }
}

export function setDelmanDevice(binding: DelmanDeviceBinding): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(binding))
}

export function clearDelmanDevice(): void {
  localStorage.removeItem(STORAGE_KEY)
}

export function hasDelmanDevice(): boolean {
  return getDelmanDevice() !== null
}
